// v3.94 - MISSED-ID-04 EDGS: HIGH-risk employment data disclaimer banner - 2026-04-25
//
// Tier 2 EDGS disclaimer. Shown only when risk_level === "HIGH".
// Blocking reveal: answer text is hidden behind this banner until user acknowledges.
// MEDIUM risk uses the lighter MUI Alert inline (Tier 1, handled in ChatWidget).

import React, { useState } from 'react';
import {
    Box,
    Button,
    Paper,
    Typography,
    Collapse,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface DataDisclaimerBannerProps {
    disclaimerText: string;
    children: React.ReactNode;   // the answer content to reveal after acknowledgement
}

export function DataDisclaimerBanner({ disclaimerText, children }: DataDisclaimerBannerProps) {
    const [acknowledged, setAcknowledged] = useState(false);

    if (acknowledged) {
        return <>{children}</>;
    }

    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2,
                borderColor: 'warning.main',
                borderWidth: 2,
                borderRadius: 2,
                backgroundColor: 'warning.50',
            }}
        >
            <Box display="flex" alignItems="flex-start" gap={1.5} mb={1.5}>
                <WarningAmberIcon color="warning" sx={{ mt: 0.25 }} />
                <Box>
                    <Typography variant="subtitle2" color="warning.dark" fontWeight={600}>
                        Employment Data Notice
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mt={0.5}>
                        {disclaimerText ||
                            'This answer contains workforce data that may relate to employment decisions. ' +
                            'Use for business planning purposes only. Do not use to make decisions about ' +
                            'individual employees without appropriate HR review.'}
                    </Typography>
                </Box>
            </Box>
            <Collapse in={false}>
                {/* placeholder — content revealed after acknowledgement */}
            </Collapse>
            <Button
                variant="contained"
                color="warning"
                size="small"
                onClick={() => setAcknowledged(true)}
                sx={{ mt: 0.5 }}
            >
                I understand — show answer
            </Button>
        </Paper>
    );
}

export default DataDisclaimerBanner;
